import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { NavigationService } from 'src/app/services/navigation.service';
import { PromotionService } from 'src/app/services/promotion.service';
import * as _ from "lodash";
import Swal from 'sweetalert2';
import { NotificationService } from 'src/app/services/notification-service';

@Component({
  selector: 'app-shop-promotions',
  templateUrl: './shop-promotions.component.html',
  styleUrls: ['./shop-promotions.component.scss']
})
export class ShopPromotionsComponent implements OnInit {
    filterValue: string = "";
    data = [];
    dataSource = new MatTableDataSource(this.data);
    displayedColumns: string[] = [
      "promotion",
      "price",
      "product_name",
      "sub_category_name",
      "start_date",
      "expiry_date",
      "action"
    ];

    @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
    @ViewChild(MatSort, { static: true }) sort: MatSort;
    @ViewChild("searchInput", { static: true }) searchInput: ElementRef;
    dataExcel: any[];
  constructor(private navigationService:NavigationService,private promotionService:PromotionService,private toast:NotificationService) { }

  ngOnInit() {
    this.getTableData('')
  }

  getTableData(data) {
    if (data) {
      data = { SearchQuery: data }
    }
    this.promotionService.getPromotions(data).subscribe((result) => {
      this.data = [];
      this.dataExcel = [];
      this.data = result;
      this.dataExcel = result;
      this.data = _.orderBy(this.data, ["priority"]);
      this.dataSource = new MatTableDataSource(this.data);
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;
    });
  }
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.filterValue = filterValue;
    this.dataSource.filter = filterValue.trim().toLowerCase();
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }
  clearFilter() {
    const inputElement = document.getElementById('filter-input') as HTMLInputElement;
    if (inputElement) {
      inputElement.value = '';
    }
    this.dataSource.filter = '';
    this.searchInput.nativeElement.value = "";
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
    this.dataSource.sort.active = '';
    this.dataSource.sort.direction = '';
    this.dataSource.sort.sortChange.emit({ active: '', direction: '' });
    this.getTableData('');
  }
  goToManagePromotionForm(id) {
    this.navigationService.goToManagePromotionForm(id);
  }
  delete(promotion) {
    debugger
    Swal.fire({
        title:"You want to deactivate this promotion?",
        icon:'warning',
        showConfirmButton:true,
        confirmButtonText:'Yes',
        showCancelButton:true,
        cancelButtonText:"No"
    }).then(res=>{
        if(res.isConfirmed){
            this.promotionService.deletePromotion(promotion).subscribe( (results)=> {
                this.toast.showSuccess('Deactivated Successfully');
                this.getTableData('');
            });
        }
    })
  }
}
